import { useLoading } from "@hooks";
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { getCurrentCulture } from "@utils";
import { DefaultPath } from "@utils/common/defaultRoutePathsEnum";

export default function ActivationInProgress() {
	const { t } = useTranslation();

	const { isLoading } = useLoading();

	if (!isLoading) {
		return null;
	}

	return (
		<div className="card--primary card--shadowy card--message">
			<div className="card--message__thumb" />
			<div className="card--message__body">
				<div className="card--message__content">
					<i className="card--message__icon u-icon u-icon--xlrg u-icon--alert-circle u-icon--animated--bounce-in u-color--sent--warning" />
					<div className="card--message__title">
						{t<string>(
							"MEMBERSHIP.ACCOUNT_ACTIVATION.ACTIVATION_PROGRESS"
						)}
					</div>
					<div>
						{t<string>("MEMBERSHIP.ACCOUNT_ACTIVATION.PLEASE_WAIT")}
					</div>
					<div className="card--message__footer">
						<Link
							className="card--message__cta btn btn--base btn--block btn--primary"
							to={`/${getCurrentCulture()}/${DefaultPath.HOME}`}
						>
							{t<string>("MEMBERSHIP.ACCOUNT_ACTIVATION.HOME")}
						</Link>
					</div>
				</div>
			</div>
		</div>
	);
}
